module.exports = __webpack_public_path__ + "img/main_sampleimg.374dd38.png";